// ! UTILITY ENUMS TO ASSIST WITH DB
export const CrewClaimTypeEnum = {
    warranty: 'Warranty',
    return: 'Return',
};
// ! ensure that new columns are added to apps/api/src/services/crew/reports.ts where the reports are generated
export var ReportColumn;
(function (ReportColumn) {
    ReportColumn["claimId"] = "claim_id";
    ReportColumn["customerName"] = "customer_name";
    ReportColumn["original_order_number"] = "original_order_number";
    ReportColumn["original_order_date"] = "original_order_date";
    ReportColumn["claimStatus"] = "claim_status";
    ReportColumn["productName"] = "product_name";
    ReportColumn["customerEmail"] = "customer_email";
    ReportColumn["sku"] = "sku";
    ReportColumn["price"] = "price";
    ReportColumn["quantity"] = "quantity";
    ReportColumn["lineItemStatus"] = "line_item_status";
    ReportColumn["lineItemStatusDetail"] = "line_item_status_detail";
    ReportColumn["lineItemReason"] = "line_item_reason";
    ReportColumn["lineItemReasonDetail"] = "line_item_reason_detail";
    ReportColumn["requestedResolutionMethod"] = "requested_resolution_method";
    ReportColumn["resolutionMethod"] = "resolution_method";
    ReportColumn["createdDate"] = "created_date";
    ReportColumn["inspectionGrade"] = "inspection_grade";
    ReportColumn["inspectionDate"] = "inspection_date";
})(ReportColumn || (ReportColumn = {}));
export var InventoryBehavior;
(function (InventoryBehavior) {
    InventoryBehavior["bypass"] = "bypass";
    InventoryBehavior["decrementIgnoringPolicy"] = "decrement_ignoring_policy";
    InventoryBehavior["decrementObeyingPolicy"] = "decrement_obeying_policy";
})(InventoryBehavior || (InventoryBehavior = {}));
export var CrewMetricType;
(function (CrewMetricType) {
    CrewMetricType["totalOrders"] = "Total_Orders";
    CrewMetricType["ordersWithReturns"] = "Orders_With_Returns";
    CrewMetricType["totalReturnClaims"] = "Total_Return_Claims";
    CrewMetricType["totalOrderRevenue"] = "Total_Order_Revenue";
    CrewMetricType["totalReturnedRevenue"] = "Total_Returned_Revenue";
    CrewMetricType["totalRefundedRevenue"] = "Total_Refunded_Revenue";
    CrewMetricType["totalOutstandingReturnRevenue"] = "Total_Outstanding_Return_Revenue";
    CrewMetricType["totalSavedRevenue"] = "Total_Saved_Revenue";
    CrewMetricType["refundedRevenueRate"] = "Refunded_Revenue_Rate";
})(CrewMetricType || (CrewMetricType = {}));
export const ClaimPaymentStatus = {
    authorized: 'Authorized',
    captured: 'Captured',
    refunded: 'Refunded',
};
// added for display purposes just in case the enum values are ever extended and contain a non-merchant-friendly value
export const crewClaimTypeEnumName = {
    [CrewClaimTypeEnum.warranty]: 'Warranty',
    [CrewClaimTypeEnum.return]: 'Return',
};
export const crewClaimTypeEnumPluralizedName = {
    [CrewClaimTypeEnum.return]: 'Returns',
    [CrewClaimTypeEnum.warranty]: 'Warranties',
};
export var CrewIncentiveTypeEnum;
(function (CrewIncentiveTypeEnum) {
    CrewIncentiveTypeEnum["percent"] = "Percent";
    CrewIncentiveTypeEnum["fixed"] = "Fixed";
    CrewIncentiveTypeEnum["none"] = "None";
})(CrewIncentiveTypeEnum || (CrewIncentiveTypeEnum = {}));
export var CrewShippingDirectionEnum;
(function (CrewShippingDirectionEnum) {
    CrewShippingDirectionEnum["toCustomer"] = "To_Customer";
    CrewShippingDirectionEnum["fromCustomer"] = "From_Customer";
})(CrewShippingDirectionEnum || (CrewShippingDirectionEnum = {}));
// ------------------ CREW INSPECTION Classifications ------------------ //
export var InspectionGradeCode;
(function (InspectionGradeCode) {
    InspectionGradeCode["aStock"] = "A_Stock";
    InspectionGradeCode["bStock"] = "B_Stock";
    InspectionGradeCode["dispose"] = "Dispose";
})(InspectionGradeCode || (InspectionGradeCode = {}));
export const inspectionGradeCodeNames = {
    [InspectionGradeCode.aStock]: 'A-Stock',
    [InspectionGradeCode.bStock]: 'B-Stock',
    [InspectionGradeCode.dispose]: 'Dispose',
};
//* claim resolution method enum is used by GSP and CREW *//
export var CrewClaimResolutionMethodEnum;
(function (CrewClaimResolutionMethodEnum) {
    CrewClaimResolutionMethodEnum["refund"] = "Refund";
    CrewClaimResolutionMethodEnum["variantExchange"] = "Variant_Exchange";
    CrewClaimResolutionMethodEnum["giftCard"] = "Gift_Card";
    CrewClaimResolutionMethodEnum["repair"] = "Repair";
    CrewClaimResolutionMethodEnum["replacementOrder"] = "Replacement_Order";
    CrewClaimResolutionMethodEnum["warrantyReview"] = "Warranty_Review";
})(CrewClaimResolutionMethodEnum || (CrewClaimResolutionMethodEnum = {}));
// ! only used on old claims layout
export const SearchableCrewClaimResolutionMethod = {
    refund: CrewClaimResolutionMethodEnum.refund,
    variantExchange: CrewClaimResolutionMethodEnum.variantExchange, // ? one for one of the same product
    giftCard: CrewClaimResolutionMethodEnum.giftCard,
    warrantyReview: CrewClaimResolutionMethodEnum.warrantyReview,
};
export const crewClaimResolutionMethodEnumName = {
    [CrewClaimResolutionMethodEnum.refund]: 'Refund',
    [CrewClaimResolutionMethodEnum.variantExchange]: 'Exchange',
    [CrewClaimResolutionMethodEnum.giftCard]: 'Gift Card',
    [CrewClaimResolutionMethodEnum.repair]: 'Repair',
    [CrewClaimResolutionMethodEnum.replacementOrder]: 'Replacement Order',
    [CrewClaimResolutionMethodEnum.warrantyReview]: 'Warranty Review',
};
// ------------------ CREW CLAIM REASON CATEGORY CODES ------------------ //
export var CrewClaimReasonCategoryCode;
(function (CrewClaimReasonCategoryCode) {
    CrewClaimReasonCategoryCode["defectiveItem"] = "Defective_Item";
    CrewClaimReasonCategoryCode["wrongFit"] = "Wrong_Fit";
    CrewClaimReasonCategoryCode["notAsExpected"] = "Not_As_Expected";
    CrewClaimReasonCategoryCode["notSatisfied"] = "Not_Satisfied";
    CrewClaimReasonCategoryCode["noLongerNeeded"] = "No_Longer_Needed";
    CrewClaimReasonCategoryCode["wrongItem"] = "Wrong_Item";
    CrewClaimReasonCategoryCode["shippingIssue"] = "Shipping_Issue";
})(CrewClaimReasonCategoryCode || (CrewClaimReasonCategoryCode = {}));
export const crewClaimReasonCategoryCodeName = {
    [CrewClaimReasonCategoryCode.defectiveItem]: 'Defective Item',
    [CrewClaimReasonCategoryCode.wrongFit]: 'Wrong Fit',
    [CrewClaimReasonCategoryCode.notAsExpected]: 'Not As Expected',
    [CrewClaimReasonCategoryCode.notSatisfied]: 'Not Satisfied',
    [CrewClaimReasonCategoryCode.noLongerNeeded]: 'No Longer Needed',
    [CrewClaimReasonCategoryCode.wrongItem]: 'Wrong Item',
    [CrewClaimReasonCategoryCode.shippingIssue]: 'Shipping Issue',
};
// ------------------ CREW CLAIM CUSTOMER EMAIL TYPES ------------------ //
export var AutomatedEmailTypeEnum;
(function (AutomatedEmailTypeEnum) {
    // ? automated emails
    AutomatedEmailTypeEnum["returnExpiring"] = "Return_Expiring";
    AutomatedEmailTypeEnum["returnReminder"] = "Return_Reminder";
    AutomatedEmailTypeEnum["claimSubmitted"] = "Claim_Submitted";
    AutomatedEmailTypeEnum["registrationSubmitted"] = "Registration_Submitted";
    AutomatedEmailTypeEnum["warrantySubmitted"] = "Warranty_Submitted";
})(AutomatedEmailTypeEnum || (AutomatedEmailTypeEnum = {}));
export var FinalizationEmailTypeEnum;
(function (FinalizationEmailTypeEnum) {
    // ? finalization / processing emails
    FinalizationEmailTypeEnum["claimApprovedAsRequested"] = "Claim_Approved_As_Requested";
    FinalizationEmailTypeEnum["claimApprovedNotAsRequested"] = "Claim_Approved_Not_As_Requested";
    FinalizationEmailTypeEnum["claimDenied"] = "Claim_Denied";
    FinalizationEmailTypeEnum["claimNeedsMoreInfo"] = "Claim_Needs_More_Info";
    FinalizationEmailTypeEnum["warrantyApprovedAsRequested"] = "Warranty_Approved_As_Requested";
    FinalizationEmailTypeEnum["warrantyApprovedNotAsRequested"] = "Warranty_Approved_Not_As_Requested";
    FinalizationEmailTypeEnum["warrantyDenied"] = "Warranty_Denied";
})(FinalizationEmailTypeEnum || (FinalizationEmailTypeEnum = {}));
// ------------------ CREW CLAIM RETURN SHIPMENT TYPES ------------------ //
export var ShipmentMethod;
(function (ShipmentMethod) {
    ShipmentMethod["packingSlip"] = "Packing_Slip";
    ShipmentMethod["label"] = "Label";
})(ShipmentMethod || (ShipmentMethod = {}));
// ------------------ CREW CLAIM STATUS CODES ------------------ //
export var CrewClaimRollupStatusCode;
(function (CrewClaimRollupStatusCode) {
    CrewClaimRollupStatusCode["inProgress"] = "In_Progress";
    CrewClaimRollupStatusCode["readyForReview"] = "Ready_For_Review";
    CrewClaimRollupStatusCode["completed"] = "Completed";
})(CrewClaimRollupStatusCode || (CrewClaimRollupStatusCode = {}));
export const crewClaimRollupStatusCodeName = {
    [CrewClaimRollupStatusCode.inProgress]: 'In Progress',
    [CrewClaimRollupStatusCode.readyForReview]: 'Ready For Review',
    [CrewClaimRollupStatusCode.completed]: 'Completed',
};
// ------------------ CREW CLAIM LINE ITEM STATUS CODES ------------------ //
export const CrewClaimStatusCode = {
    open: 'Open',
    approved: 'Approved',
    denied: 'Denied',
    // TODO: Rename this to "Canceled" to better match what the Shopify API uses
    closed: 'Closed',
    // remove all of these at some point
    awaitingReturn: 'Awaiting_Return',
    inTransit: 'In_Transit',
    atReturnLocation: 'At_Return_Location',
};
export const CrewClaimStatusDetailCode = {
    finalSale: 'Final_Sale',
    pendingReview: 'Pending_Review',
    pendingAdditionalInfo: 'Pending_Additional_Info',
    awaitingCustomerDropoffLabelProvided: 'Awaiting_Customer_Dropoff_Label_Provided',
    awaitingCustomerDropOffPackingSlipProvided: 'Awaiting_Customer_Dropoff_Packing_Slip_Provided',
    inTransit: 'In_Transit',
    pendingInspection: 'Pending_Inspection',
    pendingApproval: 'Pending_Approval',
    variantExchange: 'Variant_Exchange',
    giftCardIssued: 'Gift_Card_Issued',
    refunded: 'Refunded',
    refundedPartial: 'Refunded_Partial',
    gifCardIssuedPartial: 'Gift_Card_Issued_Partial',
    replacementOrder: 'Replacement_Order',
    repaired: 'Repaired',
    wrongItem: 'Wrong_Item',
    itemNotReturned: 'Item_Not_Returned',
    noncompliantReturn: 'Noncompliant_Return',
    notCoveredUnderWarranty: 'Not_Covered_Under_Warranty',
    pendingReturnShipmentCreation: 'Pending_Return_Shipment_Creation',
    returnNotRequired: 'Return_Not_Required',
    additionalInfoNotProvided: 'Additional_Info_Not_Provided',
    noActionTaken: 'No_Action_Taken',
};
const claimStatusOpen = {
    code: CrewClaimStatusCode.open,
    name: 'Open',
    claimStatusDetail: [
        { code: CrewClaimStatusDetailCode.pendingReview, name: 'Pending Review' },
        {
            code: CrewClaimStatusDetailCode.pendingAdditionalInfo,
            name: 'Pending Additional Info',
        },
        {
            code: CrewClaimStatusDetailCode.pendingReturnShipmentCreation,
            name: 'Pending Return Shipment Creation',
        },
        {
            code: CrewClaimStatusDetailCode.returnNotRequired,
            name: 'Return Not Required',
        },
    ],
};
const claimStatusAwaitingReturn = {
    code: CrewClaimStatusCode.awaitingReturn,
    name: 'Awaiting Return',
    claimStatusDetail: [
        {
            code: CrewClaimStatusDetailCode.awaitingCustomerDropoffLabelProvided,
            name: 'Awaiting Customer Dropoff',
        },
        {
            code: CrewClaimStatusDetailCode.awaitingCustomerDropOffPackingSlipProvided,
            name: 'Awaiting Customer Dropoff',
        },
    ],
};
const claimStatusInTransit = {
    code: CrewClaimStatusCode.inTransit,
    name: 'In Transit',
    claimStatusDetail: [
        { code: CrewClaimStatusDetailCode.inTransit, name: 'In Transit' },
    ],
};
const claimStatusAtReturnLocation = {
    code: CrewClaimStatusCode.atReturnLocation,
    name: 'At Return Location',
    claimStatusDetail: [
        {
            code: CrewClaimStatusDetailCode.pendingInspection,
            name: 'Pending Inspection',
        },
        {
            code: CrewClaimStatusDetailCode.pendingApproval,
            name: 'Pending Approval',
        },
        {
            code: CrewClaimStatusDetailCode.pendingAdditionalInfo,
            name: 'Pending Additional Info',
        },
    ],
};
const claimStatusApproved = {
    code: CrewClaimStatusCode.approved,
    name: 'Approved',
    claimStatusDetail: [
        {
            code: CrewClaimStatusDetailCode.variantExchange,
            name: 'Variant Exchange',
        },
        {
            code: CrewClaimStatusDetailCode.giftCardIssued,
            name: 'Gift Card',
        },
        {
            code: CrewClaimStatusDetailCode.refunded,
            name: 'Refund',
        },
        {
            code: CrewClaimStatusDetailCode.refundedPartial,
            name: 'Partial Refund',
        },
        {
            code: CrewClaimStatusDetailCode.gifCardIssuedPartial,
            name: 'Partial Gift Card',
        },
        {
            code: CrewClaimStatusDetailCode.replacementOrder,
            name: 'Replacement Order',
        },
        {
            code: CrewClaimStatusDetailCode.repaired,
            name: 'Repaired',
        },
    ],
};
const claimStatusClosed = {
    // TODO: rename this to "Canceled" to better match what the Shopify API uses
    code: CrewClaimStatusCode.closed,
    name: 'Canceled',
    claimStatusDetail: [
        {
            code: CrewClaimStatusDetailCode.noActionTaken,
            name: 'Nothing Issued',
        },
    ],
};
// -------- DENIED CLAIM STATUS DETAILS -------- //
const claimStatusDenied = {
    code: CrewClaimStatusCode.denied,
    name: 'Denied',
    claimStatusDetail: [
        {
            code: CrewClaimStatusDetailCode.wrongItem,
            name: 'Wrong Item',
        },
        {
            code: CrewClaimStatusDetailCode.itemNotReturned,
            name: 'Item Not Returned',
        },
        {
            code: CrewClaimStatusDetailCode.noncompliantReturn,
            name: 'Non-compliant Return',
        },
        {
            code: CrewClaimStatusDetailCode.notCoveredUnderWarranty,
            name: 'Not Covered Under Warranty',
        },
        {
            code: CrewClaimStatusDetailCode.noActionTaken,
            name: 'Nothing Issued Inside Corso',
        },
        // ? additional info not provided was removed
    ],
};
/**
 * Helper object to assist with seeding and know which `claim_status_detail` records apply to which `claim_status`.
 * Should be instead of the underlying `claim_status_detail` related enum when working with related statuses and details.
 */
// TODO revise maybe as an object-based access of details instead of index-based access
export const crewClaimStatuses = {
    [CrewClaimStatusCode.open]: claimStatusOpen,
    [CrewClaimStatusCode.awaitingReturn]: claimStatusAwaitingReturn,
    [CrewClaimStatusCode.inTransit]: claimStatusInTransit,
    [CrewClaimStatusCode.atReturnLocation]: claimStatusAtReturnLocation,
    [CrewClaimStatusCode.approved]: claimStatusApproved,
    [CrewClaimStatusCode.denied]: claimStatusDenied,
    [CrewClaimStatusCode.closed]: claimStatusClosed,
};
//# sourceMappingURL=crew.js.map